import Component from '../inherited/Component'

export default class Animate extends Component {
  constructor(elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
  }

  mount() {
    if (!this._options.class) {
      return
    }

    window.addEventListener('scroll', () => {
      if (this._elem.getBoundingClientRect().top <= 400) {
        this._elem.classList.add(this._options.class)
      }
    })
  }
}
